export enum Permission {
  NV = "nv",
  CN = "cn",
  V = "v",
  VO = "vo",
  EA = "ea",
  EO = "eo",
  A = "a",
}
